<template>

    <div></div>

</template>

<script>

    export default {
        name: "salir",
        props: {
            source: String,
        },
        mounted() {
                this.$store.dispatch("removeToken")
                this.$router.push('/login')
        }
    }
</script>
